import * as React from 'react'
import Position from '../components/base/Position'
import Main from '../components/Main'
const NotFoundPage = () => (
  <Main>
    <Position title={'404'}/>
    <h1>You are here!</h1>
    <h2>But nothing found for you #404</h2>
  </Main>
)

export default NotFoundPage
